import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import Modal from "@material-ui/core/Modal";
// import Backdrop from "@material-ui/core/Backdrop";
// import Fade from "@material-ui/core/Fade";
import { Modal, Backdrop, Fade, Paper } from "@mui/material";
// const useStyles = makeStyles((theme) => ({
//   modal: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   paper: {
//     backgroundColor: theme.palette.background.paper,
//     boxShadow: theme.shadows[5],
//     position: "relative",
//     margin: "10px",
//     zIndex: 10,
//   },
// }));

const ModalBasic = (props) => {
  const { children, close, customClass, open, hideCloseIcon } = props;
  // const classes = useStyles();

  return (
    <div className={customClass}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        open={open}
        onClose={() => close(false)}
        closeAfterTransition
      >
        <Fade in={open}>
          <Paper>
            {!hideCloseIcon && (
              <div onClick={close} className="close">
                ✕
              </div>
            )}
            {children}
          </Paper>
        </Fade>
      </Modal>
    </div>
  );
};

export default ModalBasic;
